export default __webpack_public_path__ + "static/media/web.6fbc930b.jpg";